import { render, staticRenderFns } from "./ModalAlertPartnerNotConnect.vue?vue&type=template&id=9cd55e64&scoped=true&"
import script from "./ModalAlertPartnerNotConnect.vue?vue&type=script&lang=ts&"
export * from "./ModalAlertPartnerNotConnect.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAlertPartnerNotConnect.vue?vue&type=style&index=0&id=9cd55e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd55e64",
  null
  
)

export default component.exports